import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import { WorksheetRenderer, WorksheetChangesModal, BusinessSearchModal } from '..';
import './WorksheetsRenderer.less';

const WorksheetsRenderer: React.FC = () => {
    const { worksheetsStore, documentVisualStore, inputsStore } = useAppStore();

    React.useEffect(() => {
        const subject = documentVisualStore.highlightedInputIdSubject.subscribe(inputGuid => {
            if (!inputGuid) {
                inputsStore.setHighlightedInputGuid(null);
                return;
            }

            const input = worksheetsStore.getInputByGuid(inputGuid);

            if (!input || !input.node.worksheet) {
                return;
            }

            const addDelay = !input.node.worksheet.isSelected;

            worksheetsStore.selectWorksheet(input.node.worksheet);
            input.node.setExpanded(true);
            inputsStore.setHighlightedInputGuid(inputGuid, addDelay ? 300 : 0);
        });

        return () => subject.unsubscribe();
    }, [worksheetsStore, documentVisualStore, inputsStore]);

    return (
        <div className="worksheets-renderer-container">
            <BusinessSearchModal />

            {worksheetsStore.selectedWorksheet && (
                <WorksheetChangesModal worksheet={worksheetsStore.selectedWorksheet} />
            )}

            {worksheetsStore.worksheets.map(worksheet => (
                <WorksheetRenderer key={worksheet.id} worksheet={worksheet} />
            ))}
        </div>
    );
};

export default observer(WorksheetsRenderer);
